import { CUSTOM_DOCUMENT_REQUEST } from '../actionTypes';

const initialState = {
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CUSTOM_DOCUMENT_REQUEST.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
